<div class="modal-header">
    <h5>{{ title }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div id="modalBody" class="modal-body">
    <form [formGroup]="signatureForm" novalidate>
        <div class="form-group col-12">
            <div class="form-group">
                <label for="lastName" class="form-control-label">{{ 'Name' | translate }}
                    <span class="required"> *</span></label>
                <input class="form-control form-control-sm" id="name" formControlName="name">
                <div class="form-control-feedback"
                    *ngIf="signatureForm.get('name').hasError('required') && signatureForm.get('name').touched">
                    <small class="form-text">{{ 'NameRequired' | translate }}</small>
                </div>
            </div>
        </div>
        <div class="form-group col-12">
            <div class="form-group">
                <label class="form-control-label">{{ 'Signature' | translate }}<span class="required"> *</span></label>
                <mrm-signature-pad class="signaturePad" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                    (onEndEvent)="drawComplete()"></mrm-signature-pad>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer" ng-show="true">
    <div class="col-lg-12 text-right">
        <input id="ok" type="button" class="btn btn-primary" value="{{ 'Ok' | translate }}" (click)="ok()" />
        <input id="clear" type="button" class="btn btn-info" value="{{ 'Clear' | translate }}" (click)="clear()"
            [disabled]="signatureCompleted" />
        <input id="cancel" type="button" class="btn btn-secondary" value="{{ 'Cancel' | translate }}"
            (click)="cancel()" />
    </div>
</div>